import React from 'react';
import { useDispatch } from 'react-redux';
import { Block } from '../../../components';
import { BtnRequest as Button } from '../../procedures/modules/requests/IssuanceUniversityCard/info/components/styled';
import utpLogo from '../../../../assets/images/utp-logo.png';
import { Creators as signOutActions } from '../../../../domain/useCases/login/signOutUseCase';
import { ContainerNotEnrolled } from '../styles';
import NotEnrolledInfo from './NotEnrolledInfo';

interface NotEnrolledPageProps {
  isAdmin?: boolean;
}

const NotEnrolledPage = (props: NotEnrolledPageProps) => {
  const { isAdmin } = props;
  const dispatch = useDispatch();
  return (
    <ContainerNotEnrolled>
      <div style={{ alignItems: 'baseline' }}>
        {!isAdmin && <img className="logo" src={utpLogo} alt="" />}
        <NotEnrolledInfo />
        {!isAdmin && (
          <Block className="buttonDef">
            <Button
              className="button"
              onClick={() => {
                dispatch(signOutActions.signOut());
              }}
            >
              <p>Cerrar sesión</p>
            </Button>
          </Block>
        )}
      </div>
    </ContainerNotEnrolled>
  );
};

export default NotEnrolledPage;
